import { FC, useState } from "react";

import { InputFieldAuthHideProps } from "./types.ts";
import { EyeIcon } from "../icons/EyeIcon.tsx";
import InputFieldAuth from "../InputFieldAuth/InputFieldAuth.tsx";

import styles from "./InputFieldAuthHide.module.css";



const InputFieldAuthHide: FC<InputFieldAuthHideProps> = ({ ...props }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={styles.input}>
      <InputFieldAuth {...props} type={isVisible ? "text" : "password"} />
      <button className={styles.input__icon} onClick={() => setIsVisible(!isVisible)} type="button">
        <EyeIcon />
      </button>
    </div>
  );
};

export default InputFieldAuthHide;
